import Closable from "components/behaviors/closable";

import { useEffect, useState } from "react";

type FloatingMenuProps = {
  onChange: (visible: boolean) => void;
  children: React.ReactNode;
  visible?: boolean;
};

export default function FloatingMenu(props: FloatingMenuProps): JSX.Element {
  const { onChange } = props;

  const [visible, setVisible] = useState(true);

  useEffect(() => {
    onChange(visible);
  }, [visible, onChange]);

  if (!visible) return <></>;

  return (
    <Closable onClose={() => setVisible(false)}>
      <menu className="floating-menu absolute z-20 right-0 top-0 my-0 pl-0 py-2 bg-white border border-gray-300 rounded-md shadow-xl list-none">
        {props.children}

        <style jsx>{`
          .floating-menu {
            min-width: 224px;
          }

          .floating-menu :global(li) {
            @apply flex items-center px-4 py-2 bg-white hover:bg-gray-50 active:bg-gray-100 cursor-pointer whitespace-nowrap;
          }

          .floating-menu :global(svg) {
            @apply mr-4;
          }
        `}</style>
      </menu>
    </Closable>
  );
}
